import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3c7.2 0 9 1.8 9 9c0 7.2 -1.8 9 -9 9c-7.2 0 -9 -1.8 -9 -9c0 -7.2 1.8 -9 9 -9","key":"svg-0"}],["path",{"d":"M12 16v.01","key":"svg-1"}],["path",{"d":"M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483","key":"svg-2"}]]

const IconHelpSquareRounded = createReactComponent('outline', 'help-square-rounded', 'HelpSquareRounded', __iconNode);

export default IconHelpSquareRounded;